import React, { useState, useEffect } from 'react';

const Matches = () => {
  const fields = [
  { title: "I. pálya", id: 1 },   // Changed id to number matching match.field
  { title: "II. pálya", id: 2 },
];

  const [matchData, setMatchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  //const API_BASE_URL =  'tournament-be.vercel.app';
  const API_BASE_URL = 'http://localhost:3306/api'; // Adjust this to your backend API base URL

  // Function to generate time slots starting from 08:30
  const generateTimeSlots = (count) => {
    const slots = [];
    let hour = 8;
    let minute = 30;

    for (let i = 0; i < count; i++) {
      // Format start time
      const startTime = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;

      // Add 30 minutes for end time
      minute += 30;
      if (minute >= 60) {
        hour += 1;
        minute -= 60;
      }

      // Format end time
      const endTime = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;

      slots.push(`${startTime}-${endTime}`);
    }

    return slots;
  };

  // Function to convert group ID to letter (1 -> A, 2 -> B, etc.)
  const groupIdToLetter = (id) => {
    return String.fromCharCode(64 + parseInt(id));
  };

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/matches`);

        if (!response.ok) {
          throw new Error(`Failed to load matches: ${response.status}`);
        }

        const data = await response.json();
        console.log("Fetched matches:", data); // <- 🔍 Add this line

        // Preserve the original database order
        setMatchData(data);
      } catch (err) {
        setError(err.message);
        console.error('Matches fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, []);

  // Process match data for each field
  const processFieldMatches = () => {
  return fields.map(field => {
    const matchesForField = matchData
      .filter(match => match.field === field.id && match.order_by_field > 0)
      .sort((a, b) => a.order_by_field - b.order_by_field);

    // Find the maximum order to determine table length
    const maxOrder = matchesForField.length > 0
      ? Math.max(...matchesForField.map(match => match.order_by_field))
      : 0;

    const filledMatches = [];

    for (let i = 1; i <= maxOrder; i++) {
      const match = matchesForField.find(m => m.order_by_field === i);
      if (match) {
        filledMatches.push({
          ...match,
          groupLetter: groupIdToLetter(match.group_id),
        });
      } else {
        // Insert a placeholder
        filledMatches.push({
          id: `placeholder-${field.id}-${i}`,
          time: '', // time will be filled below
          groupLetter: '',
          home_team_name: '',
          away_team_name: '',
          home_goals: null,
          away_goals: null,
          isPlaceholder: true,
        });
      }
    }

    // Generate time slots for total length
    const timeSlots = generateTimeSlots(filledMatches.length);

    // Assign time to each row
    const matchesWithTime = filledMatches.map((match, index) => ({
      ...match,
      time: timeSlots[index]
    }));

    return {
      ...field,
      matches: matchesWithTime
    };
  });
};



  // Render loading state
  if (loading) {
    return (
      <div className="matches-page main-content">
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading matches...</p>
        </div>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="matches-page main-content">
        <div className="alert alert-danger mx-auto mt-5" style={{ maxWidth: '600px' }}>
          <h2 className="h4">Error Loading Matches</h2>
          <p className="mb-1">{error}</p>
          <p className="mb-0">Please try again later or contact support.</p>
        </div>
      </div>
    );
  }

  // Get processed field matches
  const fieldMatches = processFieldMatches();

  return (
    <div className="matches-page main-content">
      <div className="fields-container">
        {fieldMatches.map((field) => (
          <div key={field.id} className="field-table-wrapper">
            <h2>{field.title}</h2>
            <table className="match-table">
              <thead>
                <tr>
                  <th>Idő</th>
                  <th>Csoport</th>
                  <th>Csapat</th>
                  <th>Eredmény</th>
                  <th>Csapat</th>
                </tr>
              </thead>
              <tbody>
                {field.matches.map((match) => (
                  <tr key={match.id}>
                    <td>{match.time}</td>
                    <td>{match.groupLetter}</td>
                    <td>{match.home_team_name}</td>
                    <td>
                      {match.home_goals === null || match.away_goals === null
                        ? '-'
                        : `${match.home_goals} - ${match.away_goals}`}
                    </td>
                    <td>{match.away_team_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Matches;